// ─── src/App.js ─────────────────────────────────────────────────────────
import React from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import useGaPageViews from "./useGaPageViews";

import HomePage      from "./pages/HomePage";
import ContactUsPage from "./pages/contact_us_page";
import PrivacyPolicyPage from "./pages/privacy_policy_page";
import CookiePolicyPage from "./pages/cookie_policy_page";
import ThankYouContactPage from "./pages/thankyouPage_contact";

import SiteFooter    from "./components/SiteFooter";

import OurTeamPage   from "./pages/our_team_page";
import TermsPage     from "./pages/terms_page";
import TrialResendLinkPage from "./pages/trial_resend_link_page";
import AppPrivacyPolicyPage from "./pages/app_privacy_policy_page";

import { emitVisitIfHighIntent } from "./webEvents";

import "./App.css";

/* Routes rendered on the warm paper ground rather than the default white. */
const PAPER_ROUTES = new Set(["/our-team", "/contact"]);

function AppRoutes() {
  const location = useLocation();
  const state = location.state && location.state.backgroundLocation ? { backgroundLocation: location.state.backgroundLocation } : {};
  const routedPath = (state.backgroundLocation || location).pathname;

  // Track SPA page views in GA4
  useGaPageViews(typeof window !== 'undefined' ? (window.__GA_MEASUREMENT_ID__ || 'G-J4VBTCE1KN') : 'G-J4VBTCE1KN');

  // Emit high-intent visit events to Event Grid (once per path per session)
  React.useEffect(() => {
    emitVisitIfHighIntent(location.pathname);
  }, [location.pathname]);

  return (
    <>
      <div className={`app-shell${PAPER_ROUTES.has(routedPath) ? " app-shell-paper" : ""}`}>
        <div className="app-main">
          <Routes location={state.backgroundLocation || location}>
            {/* ——— public marketing routes ——— */}
            <Route path="/"          element={<HomePage />} />
            <Route path="/thanks-contact" element={<ThankYouContactPage />} />
            <Route path="/our-team"  element={<OurTeamPage />} />
            <Route path="/contact"   element={<ContactUsPage />} />
            <Route path="/privacy"   element={<PrivacyPolicyPage />} />
            <Route path="/cookies"   element={<CookiePolicyPage />} />
            <Route path="/terms"     element={<TermsPage />} />
            <Route path="/trial/resend-link" element={<TrialResendLinkPage />} />
            <Route path="/app-privacy" element={<AppPrivacyPolicyPage />} />

            {/* catch‑all → home */}
            <Route path="*" element={<HomePage />} />
          </Routes>
        </div>

        <SiteFooter />
      </div>
    </>
  );
}

export default function App() {
  React.useEffect(() => {
    const link = document.getElementById("termly-preferences-link");
    const footer = document.querySelector(".site-footer");
    if (!link || !footer || footer.contains(link)) return;
    footer.appendChild(link);
  }, []);
  return (
    <Router>
      <AppRoutes />
    </Router>
  );
}
